export default __webpack_public_path__ + "static/media/add.f4d6916b.svg";